import styled from "styled-components";

const StyledContainer = styled.div`
  align-items: center;
  display: flex;
  gap: 32px;

  p {
    color: #354a5f;
    font-size: 16px;
    margin: unset;
    text-transform: capitalize;
  }

  .ant-btn {
    background: #84b8c8;
    color: #fff;
    width: 32px;

    &:hover {
      background: #e1eaed;
      color: #000;
    }
  }
`;

export default StyledContainer;
